// Structural (language-independent) data for the Hari Om Bol landing page.
// All human-readable copy lives in src/i18n/translations.js.

export const STORE_LINKS = {
  googlePlay:
    "https://play.google.com/store/apps/details?id=app.emergent.pilgrimagecompanion2f31d570e&hl=en",
  appStore: "https://apps.apple.com/in/app/hari-om-bol/id6782837850",
};

export const ASSETS = {
  logo: "https://customer-assets-eiarnc6j.emergentagent.net/job_soul-counsel-2/artifacts/jhxruhy3_ChatGPT%20Image%20Jul%204%2C%202026%2C%2001_43_02%20AM.png",
  screenAstro:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_soul-counsel-2/artifacts/zglquqir_WhatsApp%20Image%202026-09-11%20at%2015.15.04.jpeg",
  screenHome:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_soul-counsel-2/artifacts/7m59otcp_WhatsApp%20Image%202026-09-11%20at%2015.15.02.jpeg",
  screenHomeAlt:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_soul-counsel-2/artifacts/4ww1477q_WhatsApp%20Image%202026-09-11%20at%2015.15.03.jpeg",
  screenCall:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_soul-counsel-2/artifacts/vhf8wb07_WhatsApp%20Image%202026-09-17%20at%2013.23.45.jpeg",
  screenSaathi:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_soul-counsel-2/artifacts/s692rvw8_WhatsApp%20Image%202026-09-11%20at%2015.15.03%20%281%29.jpeg",
  googlePlayBadge:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_soul-counsel-2/artifacts/bvm9hrod_images%20%283%29.png",
  appStoreBadge:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_soul-counsel-2/artifacts/ujz4lloa_Download_on_the_App_Store_Badge.svg.webp",
};

// nav items: label resolved from translations.nav[key]
export const NAV_LINKS = [
  { key: "about", href: "#about" },
  { key: "features", href: "#features" },
  { key: "pricing", href: "#pricing" },
  { key: "faq", href: "#faq" },
  { key: "download", href: "#download" },
];

// feature meta: title/desc resolved from translations.why.features[index]
export const FEATURE_META = [
  { num: "01", icon: "Infinity" },
  { num: "02", icon: "BadgeCheck" },
  { num: "03", icon: "HeartHandshake" },
  { num: "04", icon: "PhoneCall" },
  { num: "05", icon: "MessageCircle" },
  { num: "06", icon: "ShieldCheck" },
];

// pack lists per currency; label strings resolved from translations
export const PACKS = {
  inr: [
    { id: "trial", price: "₹51", coins: 40, talktimeMin: 20, validityDays: 7, highlight: false, tag: "oneTimeTrial" },
    { id: "starter", price: "₹101", coins: 120, talktimeMin: 60, validityDays: 30, highlight: false, tag: null },
    { id: "popular", price: "₹251", coins: 480, talktimeMin: 240, validityDays: 180, highlight: true, tag: "mostPopular" },
    { id: "super", price: "₹501", coins: 1000, talktimeMin: 500, validityDays: 360, highlight: false, tag: "bestValue" },
  ],
  usd: [
    { id: "starter", price: "$4.00", coins: 120, talktimeMin: 60, validityDays: 30, highlight: false, tag: null },
    { id: "popular", price: "$10.00", coins: 480, talktimeMin: 240, validityDays: 180, highlight: true, tag: "mostPopular" },
    { id: "super", price: "$20.00", coins: 1000, talktimeMin: 500, validityDays: 360, highlight: false, tag: "bestValue" },
  ],
};
